import unixTime from 'unix-time';
import IdleTimer from 'react-idle-timer';
import config from "react-global-configuration";
import $ from 'jquery';


// The function js for the idle monitoring of the users 

var idleTimeMinutes = config.get('idleTimeOut');
var updateLastActiveMinutes = (Math.trunc((idleTimeMinutes * 2) / 3) - 1) < 11 ? (Math.trunc((idleTimeMinutes * 2) / 3) - 1) : 10;
var checkIdleMinutes = (Math.trunc(idleTimeMinutes / 3)) < 6 ? (Math.trunc(idleTimeMinutes / 3)) : 5;

//setInterval(updateLastActive, updateLastActiveMinutes * 60 * 1000) // to be 5 mins
//setInterval(checkIdle, checkIdleMinutes * 60 * 1000) // to be 3 mins

function randomString(length) {
    var bytes = new Uint8Array(length);
    var random = window.crypto.getRandomValues(bytes);
    var result = [];
    var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~'
    random.forEach(function (c) {
        result.push(charset[c % charset.length]);
    });
    return result.join('');
}

function updateLastActive() { //updates the last active time of user to the ticket
    var ticketName = sessionStorage.getItem('selfTicket');
    var item = localStorage.getItem(ticketName);
    var json = JSON.parse(item);

    var isIdle = json.isIdle;
    var lastActiveTime = json.lastActiveTime;
    var createdTime = json.createdTime;
    var lastModifiedTime = unixTime(new Date());

    var ticket = { "isIdle": isIdle, "lastActiveTime": lastActiveTime, "createdTime": createdTime, "lastModifiedTime": lastModifiedTime };
    localStorage.setItem(ticketName, JSON.stringify(ticket));
}

function checkIdle() {
    localStorageCheck();
}

function localStorageCheck() { //checks the idle status of the users from the tickets
    var idleStatus = true;

    $.each(localStorage, function (key, value) {
        if ("ticket_" === key.substr(0, 7)) {
            var item = value;
            var json = JSON.parse(item);
            var isIdle = json.isIdle;
            if (isIdle == '1') {
                idleStatus &= true;
            }
            else {
                idleStatus &= false;
            }
        }
    });

    if (idleStatus == true) {
        sessionStorage.removeItem('token');
        window.location.replace('/');
        // localStorage.clear();
        // window.logout.logout();
    }
}

export function storeTicket() {
    var isIdle = 0;
    var lastActiveTime = unixTime(new Date());
    var createdTime = unixTime(new Date());
    var lastModifiedTime = unixTime(new Date());
    var randomstring = randomString(20);
    var ticket = { "isIdle": isIdle, "lastActiveTime": lastActiveTime, "createdTime": createdTime, "lastModifiedTime": lastModifiedTime };
    localStorage.setItem("ticket_" + randomstring, JSON.stringify(ticket));
    sessionStorage.setItem("selfTicket", "ticket_" + randomstring);
}

export function onStorageEvent(storageEvent) {
    if (storageEvent.oldValue != null && storageEvent.newValue != null) {
        deleteOldTickets(0);

        var oldItem = JSON.parse(storageEvent.oldValue);
        var newItem = JSON.parse(storageEvent.newValue);
        var ticketName = storageEvent.key;
        if ((oldItem.isIdle != newItem.isIdle) && ("ticket_" === ticketName.substr(0, 7))) {
            localStorageCheck();
        }
    }
}

export function deleteOldTickets(decodedAuthTime) {
    var elementsForRemove = [], localLength = 0;
    var currentTime = unixTime(new Date());
    return new Promise((resolve) => {
        $.each(localStorage, function (key, value) {
            if ("ticket_" === key.substr(0, 7)) {
                var item = value;
                var json = JSON.parse(item);
                var lastModifiedTime = json.lastModifiedTime;

                if ((currentTime - lastModifiedTime) > ((updateLastActiveMinutes * 60) + 20)) {
                    elementsForRemove.push(key);
                }
                localLength++;
            }
        });
        var removeLength = elementsForRemove.length
        $.each(elementsForRemove, function (key, value) {
            localStorage.removeItem(elementsForRemove[key]);
        });
        if ((localLength == removeLength) && (removeLength > 0)) {
            if ((currentTime - decodedAuthTime) > 20) {
                window.logout.logout();
            }
            else {
                resolve();
            }
        }
        else {
            resolve();
        }
    });
}

export function onActive(e) {
    var ticketName = sessionStorage.getItem('selfTicket');
    var json;
    var item;

    item = localStorage.getItem(ticketName);
    json = JSON.parse(item);

    var isIdle = 0;
    var lastActiveTime = parseInt(this.idleTimer.getLastActiveTime().toString().substr(0, 10));
    var createdTime = json.createdTime;
    var lastModifiedTime = unixTime(new Date());

    var ticket = { "isIdle": isIdle, "lastActiveTime": lastActiveTime, "createdTime": createdTime, "lastModifiedTime": lastModifiedTime };
    localStorage.setItem(ticketName, JSON.stringify(ticket));
}

export function onIdle(e) {
    var idleStatus = true;

    var ticketName = sessionStorage.getItem('selfTicket');
    var item = localStorage.getItem(ticketName);
    var jsonSession = JSON.parse(item);

    var isIdle = 1;
    var lastActiveTime = parseInt(this.idleTimer.getLastActiveTime().toString().substr(0, 10));
    var createdTime = jsonSession.createdTime;
    var lastModifiedTime = unixTime(new Date());

    $.each(localStorage, function (key, value) {
        if ("ticket_" === key.substr(0, 7)) {
            var item = value;
            var json = JSON.parse(item);
            if (json.isIdle == '1') {
                idleStatus &= true;
            }
            else {
                idleStatus &= false;
            }
        }
    });

    if (idleStatus == true) {
        // localStorage.clear();
        // window.logout.logout();
        sessionStorage.removeItem('token');
        window.location.replace('/');
    }
    else {
        var ticket = { "isIdle": isIdle, "lastActiveTime": lastActiveTime, "createdTime": createdTime, "lastModifiedTime": lastModifiedTime };
        localStorage.setItem(ticketName, JSON.stringify(ticket));
    }
}




